module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "dayview elevation-0",
    attrs: {
      "tile": "",
      "flat": _vm.flat,
      "id": "day"
    }
  }, [_c('div', {
    staticClass: "period",
    style: ({
      height: _vm.periodInMins + 'px'
    })
  }, [_vm._v("\n    " + _vm._s(_vm.startHour) + "\n  ")]), _vm._v(" "), _vm._l((_vm.numPeriods), function(period) {
    return _c('div', {
      key: period,
      staticClass: "period",
      style: ({
        height: _vm.periodHeight + 'px'
      }),
      on: {
        "click": function($event) {
          return _vm.newEvent(period)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.timeOfDay(_vm.startHour, period, _vm.periodInMins)) + "\n  ")])
  }), _vm._v(" "), _vm._l((_vm.markedUpEvents), function(event, index) {
    return _vm._t("event", function() {
      return [_c('day-event', _vm._g({
        key: ((event.id) + "-" + index),
        attrs: {
          "selected-event": _vm.selectedEvent,
          "start-hour": _vm.startHour,
          "pixel-to-minute-ratio": _vm.pixelToMinuteRatio,
          "default-new-event-length": _vm.defaultNewEventLength
        },
        on: {
          "click": function($event) {
            if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
            return _vm.eventClicked.apply(null, arguments)
          }
        },
        model: {
          value: (_vm.markedUpEvents[index]),
          callback: function($$v) {
            _vm.$set(_vm.markedUpEvents, index, $$v)
          },
          expression: "markedUpEvents[index]"
        }
      }, _vm.$listeners))]
    })
  }), _vm._v(" "), (_vm.previewEventStyle && !_vm.previewEvent.id) ? _c('div', {
    staticClass: "event transient-event",
    style: (_vm.previewEventStyle)
  }, [_vm._v("\n    " + _vm._s(_vm.previewEvent.start_time) + " - " + _vm._s(_vm.previewEvent.end_time) + ". " + _vm._s(_vm.previewEventTitle) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('appointment-bottom-sheet', {
    attrs: {
      "appointment": _vm.selectedEvent,
      "readOnly": _vm.readOnly
    },
    model: {
      value: (_vm.bottomsheet),
      callback: function($$v) {
        _vm.bottomsheet = $$v
      },
      expression: "bottomsheet"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1643540f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/DayView.vue
// module id = 1338
// module chunks = 9